<template>
  <v-btn
      :outlined="true"
      :loading="loading"
      :disabled="loading"
      color="success"
      @click="init"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <v-icon>
      mdi-plus
    </v-icon>

    <slot/>

    <v-dialog
        v-model="dialog"
        :persistent="true"
        :scrollable="true"
        max-width="500"
    >
      <v-card>
        <v-card-title>
          Vytvoriť dokument

          <v-spacer/>

          <v-btn
              :icon="true"
              color="default"
              @click="closeDialog"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-form
              @submit.stop.prevent="submit"
          >
            <v-row>
              <v-col
                  cols="12"
              >
                <SuggestVolunteers
                    v-model="DocumentForm.Volunteer"
                    :error-messages="errors.Volunteer"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Dobrovoľník"
                    :createButton="true"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <PdfFiles
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Príloha"
                    :persistent-hint="true"
                    hint="Podporovaný formát .pdf"
                    :File="DocumentForm.File"
                    :errorsFile="errors.File"
                    @setFile="setFile"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-select
                    v-model="DocumentForm.type"
                    :error-messages="errors.type"
                    :filled="true"
                    :dense="true"
                    hide-details="auto"
                    label="Typ"
                    :items="$store.getters['register/getDocumentType']"
                    no-data-text="Žiadne výsledky"
                />
              </v-col>

              <v-col
                  cols="12"
              >
                <v-btn
                    type="submit"
                    :rounded="true"
                    :outlined="true"
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>

                  Vytvoriť
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-btn>
</template>

<script>
  import Documents from '@/services/documents'

  import PdfFiles from '@/components/Files/Pdf'

  import SuggestVolunteers from '@/components/Volunteers/Suggest'

  export default {
    name: 'Create',
    props: [
      'Volunteer'
    ],
    components: {
      PdfFiles,
      SuggestVolunteers
    },
    data() {
      return {
        loading: false,
        dialog: false,
        DocumentForm: {},
        errors: {}
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      closeDialog() {
        this.dialog = false
      },
      loadData() {
        this.dialog = true

        this.DocumentForm = {
          Volunteer: (
            this.Volunteer
              ? this.Volunteer.id
              : null
          ),
          File: null,
          type: this.$store.state.register.Document.type['contracts'].value,
        }

        this.errors = {}
      },
      setFile(File) {
        this.DocumentForm.File = File
      },
      async submit() {
        this.loading = true

        await Documents
          .create({
            data: this.DocumentForm
          })
          .then((response) => {
            this.$store.dispatch('layout/openSnackbar', {
              message: response.data.message
            })

            this.closeDialog()

            this.$emit('refresh')

            this.$emit('init')
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.closeDialog()

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
